import React from 'react';
import NotificationDetailModal from './NotificationDetailModal';
import { useNotificationDetail } from '../../hooks/useNotificationDetail';

/**
 * Provider pour gérer l'affichage des notifications push.
 * À monter une seule fois au niveau de App.tsx.
 *
 * Automatiquement:
 * - Écoute les clics sur les notifications push
 * - Gère le démarrage à froid (IndexedDB)
 * - Affiche une popup modale avec toutes les infos nécessaires
 * - Pas de dépendance à une API ou à la navigation
 */
const NotificationDetailProvider: React.FC = () => {
  const { notification, isOpen, close } = useNotificationDetail();

  if (!isOpen || !notification) return null;

  return (
    <NotificationDetailModal
      notification={notification}
      onClose={close}
    />
  );
};

export default NotificationDetailProvider;
